import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress MetaMask connection errors - app doesn't use Web3
window.addEventListener('error', (event) => {
  if (
    event.message?.includes('MetaMask') ||
    event.message?.includes('Failed to connect') ||
    event.filename?.includes('inpage.js') ||
    event.filename?.includes('content-script.js')
  ) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(onPerfEntry))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

